if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            this.setupColumnSelector();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      setupColumnSelector() {
        const dataElement = this.querySelector('[data-ob-quick-column-variants]');
        if (!dataElement) return;

        let columns;
        try {
          columns = JSON.parse(dataElement.textContent);
        } catch (error) {
          console.error('No se han podido cargar las columnas auxiliares.', error);
          return;
        }

        const variants = [
          ...(columns['70'] || []).map((variant) => ({ ...variant, size: '70' })),
          ...(columns['140'] || []).map((variant) => ({ ...variant, size: '140' })),
        ];
        if (!variants.length) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'ob-quick-column product-form__input product-form__input--dropdown';

        const label = document.createElement('label');
        label.className = 'form__label';
        label.htmlFor = `ObQuickColumn-${this.id}`;
        label.textContent = 'Columna auxiliar';

        const selectWrapper = document.createElement('div');
        selectWrapper.className = 'select';

        const select = document.createElement('select');
        select.id = label.htmlFor;
        select.className = 'select__select';
        select.setAttribute('data-ob-quick-column', '');
        select.setAttribute('aria-label', 'Columna auxiliar');

        const emptyOption = document.createElement('option');
        emptyOption.value = '';
        emptyOption.textContent = 'Sin columna';
        emptyOption.dataset.label = 'Sin columna';
        select.appendChild(emptyOption);

        const displayNames = {
          'blanco': 'Blanco',
          'blanco nordico': 'Blanco nórdico',
          'roble smoky': 'Roble Smoky',
          'estepa': 'Estepa',
          'fresno tea': 'Fresno Tea',
          'grafito': 'Grafito',
        };

        variants.forEach((variant) => {
          const option = document.createElement('option');
          const normalizedTitle = variant.title
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
          const color = displayNames[normalizedTitle] || variant.title;
          const optionLabel = `Añadir columna ${variant.size} cm (+${variant.priceLabel}) ${color}`;

          option.value = String(variant.id);
          option.textContent = variant.available ? optionLabel : `${optionLabel} — Agotada`;
          option.dataset.label = optionLabel;
          option.disabled = !variant.available;
          select.appendChild(option);
        });

        const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('class', 'icon icon-caret');
        icon.setAttribute('viewBox', '0 0 10 6');
        icon.setAttribute('aria-hidden', 'true');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('fill-rule', 'evenodd');
        path.setAttribute('clip-rule', 'evenodd');
        path.setAttribute('d', 'M9.354.646a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 1 1 .708-.708L5 4.293 8.646.646a.5.5 0 0 1 .708 0Z');
        path.setAttribute('fill', 'currentColor');
        icon.appendChild(path);

        selectWrapper.append(select, icon);
        wrapper.append(label, selectWrapper);

        const appContainer = this.modalContent.querySelector('#infiniteoptions-container');
        const appBlock = appContainer?.closest('.shopify-app-block') || appContainer;
        if (appBlock) {
          appBlock.replaceWith(wrapper);
          return;
        }

        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (variantPicker) {
          variantPicker.insertAdjacentElement('afterend', wrapper);
          return;
        }

        const productForm = this.modalContent.querySelector('product-form');
        productForm?.insertAdjacentElement('beforebegin', wrapper);
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
